import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  EnterpriseBasketService,
  EnterpriseSearchService,
  CarHireVehicleAvailibility,
  ServiceType,
  VehicleType,
  CurrencyRates,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';

import { CarDetailsComponent } from '../../../../show-details/car-details/car-details.component';

@Component({
  selector: 'app-car-item',
  templateUrl: './car-item.component.html',
  styleUrl: './car-item.component.scss',
  standalone: false
})
export class CarItemComponent extends CarDetailsComponent implements OnInit {
  @Input() result: CarHireVehicleAvailibility;
  @Input() index: number;
  @Input() results: CarHireVehicleAvailibility[] = [];
  @Input() carDetailLoadingStates: BehaviorSubject<boolean>[] = [];
  @Input() isExchange = false;
  @Input() isPricingExchange = false;
  @Output() selectExchangeCar: EventEmitter<CarHireVehicleAvailibility> = new EventEmitter();
  @Input() preferredCurency: string;
  @Input() conversionRates: { [key: string]: CurrencyRates };
  ServiceType: typeof ServiceType = ServiceType;
  public co2PerItem = '';
  public convertedPrice = '';
  public typeForDisplay = '';
  public logoUrl = '';
  public errorUrl = '';
  isSpecialVendor = false;
  isZeVendor = false;
  public carImage = '';

  constructor(
    public searchService: EnterpriseSearchService,
    protected modalService: ModalOpenerService,
    protected basketService: EnterpriseBasketService
  ) {
    super(modalService, searchService);
  }

  ngOnInit() {
    const baseUrl = 'https://images.sabscorp.com/images/carhire';
    this.logoUrl = `${baseUrl}/${this.result.displayRecord.vehicle.class.toLowerCase()}.jpg`;
    this.errorUrl = `${baseUrl}/image-unavailable.png`;
    this.isSpecialVendor = ['AL', 'ZL', 'ZE', 'SX'].includes(this.result.identifiers.vendor);
    this.carImage = `${baseUrl}/${this.result.identifiers.vendor}.gif`;
    this.isZeVendor = this.result.identifiers.vendor === 'ZE';

    this.co2PerItem = this.getCo2Usage(this.result);
    const { amount, currencyCode } = this.result.displayRecord.charges[0];
    this.convertedPrice = this.getConvertedPrice(amount, currencyCode);
    this.typeForDisplay = this.getTypeForDisplayFromResult(this.result);
  }

  /**
    @desc - for a given result return the type string for vanity purposes for a vehicle (utilising carTypeCodes in obtservices)
    @param result of type CarHireVehicleAvailibility
    @returns the car type string e.g. '2-3 Door' instead of 'TwoToThreeDoor' raw type
  **/
  getTypeForDisplayFromResult(result: CarHireVehicleAvailibility): string {
    const typeForDisplay = this.carTypeCodes.find(
      (carTypeCode) => carTypeCode[2] === result?.displayRecord?.vehicle?.type
    );
    if (typeForDisplay) {
      return typeForDisplay[1];
    }
  }

  getCo2Usage(result: CarHireVehicleAvailibility): string {
    return result?.co2PerItem ? result.co2PerItem.toFixed(2) : '0.00';
  }

  getConvertedPrice(price: string, currencyCode: string): string {
    return this.preferredCurency && this.conversionRates[currencyCode]
      ? (+price * this.conversionRates[currencyCode][this.preferredCurency]).toFixed(2)
      : price;
  }

  showSpecialFares(car: CarHireVehicleAvailibility) {
    return car.fareInfo.type === VehicleType.Private;
  }

  /**
    @desc - add a car to the basket
  **/
  addToCart(item: CarHireVehicleAvailibility): void {
    this.searchService.searches[ServiceType.Car].addCarHireToBasket(
      item,
      this.searchService.searches[ServiceType.Car].getSearchQuery()
    );
    this.basketService.toggleMenu();
  }

  exchangeCar(item: CarHireVehicleAvailibility): void {
    if (this.isExchange) {
      if (!this.isPricingExchange) {
        this.selectExchangeCar.emit(item);
      }
      return;
    }
  }

  getCarDetails(index: number): void {
    this.getCarHireAvailabilityDetail(this.results[index], index);
  }
}
